module.exports = __webpack_public_path__ + "static/img/page-not-found.3e36667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/page-not-found.png
// module id = vwgB
// module chunks = 1